import { type LiterallyAnything } from '@/types/utils';

export function memoize(fn: (...args: LiterallyAnything) => LiterallyAnything) {
	const cache: { [key: string]: LiterallyAnything } = {};

	return (...args: LiterallyAnything) => {
		// Create a key for our cache
		// This way arguments (12, 3) don't create the same key as (1, 23)
		const key = args.map(JSON.stringify).join('_');

		if (cache[key] !== undefined) {
			return cache[key];
		}

		const result = fn(...args);
		cache[key] = result;

		return result;
	};
}
